import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { formatAddress } from 'helpers/format'
import { Data } from 'Store/merchants/types'
import InfoItem from './InfoItem'

type Props = {
  detail?: Data
}

const MerchantAccount: React.FunctionComponent<Props> = props => {
  const { detail } = props

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  return (
    <BoxWrapper>
      <BoxTitle>ข้อมูลด้านการเงิน</BoxTitle>
      {renderInfo('ชื่อธนาคาร', detail?.bank_name)}
      {renderInfo('ชื่อบัญชี', detail?.account_name)}
      {renderInfo('เลขที่บัญชี', detail?.account_number)}
      {renderInfo('สาขา', detail?.bank_branch)}
      {renderInfo(
        'ที่อยู่เรียกเก็บเงิน',
        formatAddress(
          detail?.bank_receive_address,
          detail?.bank_receive_district,
          detail?.bank_receive_amphor,
          detail?.bank_receive_province,
          detail?.bank_receive_postcode,
        ),
      )}
      {renderInfo(
        'ที่อยู่จัดส่งเอกสาร',
        formatAddress(
          detail?.document_address,
          detail?.document_district,
          detail?.document_amphor,
          detail?.document_province,
          detail?.document_postcode,
        ),
      )}
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`
export default MerchantAccount
